const contentMap = new Map()
import register_gif from '@/assets/img/manual/register.gif'
import register_ip_gif from '@/assets/img/manual/register_ip.gif'
import login_gif from '@/assets/img/manual/login.gif'
import translate_gif from '@/assets/img/manual/translate.gif'
import trans_overview_gif from '@/assets/img/manual/trans_overview.gif'
import trans_single_download from '@/assets/img/manual/trans_single_download.gif'
import trans_batch_download from '@/assets/img/manual/trans_batch_download.gif'
import term_library from '@/assets/img/manual/term_library.gif'
import term_library_creat from '@/assets/img/manual/term_library_creat.gif'
import term_library_update from '@/assets/img/manual/term_library_update.gif'
import term_libray_modify_add from '@/assets/img/manual/term_libray_modify_add.gif'
import term_library_modify_modify from '@/assets/img/manual/term_library_modify_modify.gif'
import term_library_modify_single_delete from '@/assets/img/manual/term_library_modify_single_delete.gif'
import term_library_modify_batch_delete from '@/assets/img/manual/term_library_modify_batch_delete.gif'
import term_library_delete_single from '@/assets/img/manual/term_library_delete_single.gif'
import term_library_delete_batch from '@/assets/img/manual/term_library_delete_batch.gif'
import term_library_download_single from '@/assets/img/manual/term_library_download_single.gif'
import term_library_download_batch from '@/assets/img/manual/term_library_download_batch.gif'

// 获取用户类型： 1：ip  0：邮箱
let organ_type = JSON.parse(localStorage.getItem('headTop')).headTop.userInfo.organ_type

// 公司简介
contentMap.set(
  'companyIntro',
  '<h2>公司简介</h2>网易有道是中国领先的智能学习公司，致力于提供100%以用户为导向的学习产品和服务。有道成立于2006年，打造了一系列深受用户喜欢的口碑型大众学习工具产品，如：网易有道词典、有道精品课、有道翻译官、有道云笔记等。2014年，网易有道宣布正式进军互联网教育行业。'
)

// 产品简介
contentMap.set(
  'productionIntro',
  `<h2>产品介绍</h2>有道文档翻译系统2017年上线，基于有道神经网络翻译、光学字符识别、多格式文档结构解析还原技术，致力于打造一款小而精的轻量化全文翻译工具，通过浏览器，执行上传-翻译-预览-下载，全流程秒级响应，助力高教学习、科研简单高效。<br/>
  产品三大核心功能板块：立即翻译、我的任务、术语库：
  <ul class='ul-wrapper'>
    <li>【立即翻译】支持批量上传待译文档、创建翻译任务</li>
    <li>【我的任务】记录历史翻译任务，支持在线对照预览以及译文下载</li>
    <li>【术语库】支持用户上传领域术语词条，让术语机翻结果表现更一致、更专业</li>
  </ul>
`
)

// 注册
contentMap.set(
  'register',
  organ_type == 0
    ? `
      <h2>注册</h2>
      <span class="red-remark">注册所需物料：个人校内邮箱账户、手机（ps：保证邮箱可接收邮件、手机号可接受短信）</span>
      <br/>
      具体流程如下：
      <ol class='ol-wrapper'>
        <li>打开网页 <a class="link-address" href="https://doctrans-pro.youdao.com/login">https://doctrans-pro.youdao.com/login</a></li>
        <li>点击下方<span class="red-remark">“注册校内邮箱账号”</span></li>
        <li>输入个人邮箱账号→选择本校邮箱后缀→点击“获取验证码”→查看邮件→输入验证码→点击“下一步”</li>
        <li>输入手机号→点击“获取验证码”→输入验证码→点击“下一步”</li>
        <li>完善所在院系、个人姓名相关资料→点击“下一步”</li>
        <li>账号注册成功</li>
      </ol>
      <img class="gif" src="${register_gif}" />
    `
    : `<h2>注册</h2>
        <span class="red-remark">注册所需物料：手机号、验证码（ps:保证手机号可接受短信）</span>
        <br/>
        具体流程如下：
        <ol class='ol-wrapper'>
          <li>电脑连接校园网<span class="red-remark">（账号注册务必连接校园网）</span></li>
          <li>打开网页 <a class="link-address" href="https://doctrans-pro.youdao.com/login">https://doctrans-pro.youdao.com/login</a>，此时页面下方已自动识别院校，如“欢迎 郑州大学 访客”</li>
          <li>输入手机号→点击“获取验证码”→输入验证码→点击“下一步”→完善所在院系、个人姓名相关资料→点击“下一步”</li>
          <li>账号注册成功</li>
        </ol>
        <img class="gif" src="${register_ip_gif}" />
    `
)

// 登录
contentMap.set(
  'login',
  `<h2>登录</h2><span class="red-remark">登录所需物料：手机号、验证码（ps：保证手机号可接受短信）</span><br/>
    具体流程如下：
    <ol class='ol-wrapper'>
      <li>打开网页<a class="link-address" href="https://doctrans-pro.youdao.com/login">https://doctrans-pro.youdao.com/login</a></li>
      <li>输入手机号→点击“获取验证码”→输入验证码→点击“登陆”</li>
      <li>登陆成功</li>
    </ol>
    <img class="gif" src="${login_gif}" />
  `
)

// 立即翻译
contentMap.set(
  'translate',
  `<h2>立即翻译</h2>在【立即翻译】界面中，可以<span class="red-remark">批量</span>上传10个本地文档，同步并行处理，简单高效
  <ul class='ul-wrapper'>
    <li>支持格式：PDF、Docx/Doc、PPTx/PPT、TXT、图片类多种文档类型</li>
    <li>支持语种：中译英、英译中</li>
  </ul>
  具体流程如下：
  <ol class='ol-wrapper'>
    <li>点击进入【立即翻译】界面</li>
    <li>点击“点击或拖拽上传”，选取要翻译的文档</li>
    <li>点击“继续上传”（可不点击）→选择语种→选择术语表（可不选）→点击“立即翻译”</li>
  </ol>
  <img class="gif" src="${translate_gif}" />
  `
)

// 我的任务
// 我的任务-翻译预览 myTask-overview
// 我的任务-翻译下载 myTask-download
// 我的任务-翻译下载-单独下载 myTask-download-single
// 我的任务-翻译下载-批量下载 myTask-download-batch
contentMap.set(
  'myTask',
  // 我的任务
  `<h2 id="myTask">我的任务</h2>在【我的任务】界面中，可以查看历史翻译任务的文件名、页数、翻译语言、关联术语库、创建时间、任务进度等详情，并且能对翻译完成的文档进行在线对照预览、下载等操作。
    ` +
    // 我的任务-翻译预览 myTask-overview
    `
    <h3 id="myTask-overview">翻译预览</h3>支持<span class="red-remark">在线跟随式对照预览</span>，在<span class="red-remark">保证原文版式高度还原</span>的基础上，提供高质量的翻译服务
    <ol class='ol-wrapper'>
      <li>点击进入【我的任务】界面</li>
      <li>点击想要预览翻译结果的文件名，即可在线预览中英文对照翻译</li>
      <li>英译中场景下，对命中的双语术语词条，进行高亮展示</li>
    </ol>
    <img class="gif" src="${translate_gif}" />
    ` +
    // 我的任务-翻译下载 myTask-download
    `
    <h3 id="myTask-download">翻译下载</h3>翻译预览有道文档翻译系统现支持用户以word和pdf两种类型对翻译结果进行单独下载或批量下载，且支持术语高亮版本，具体流程如下：
    ` +
    // 我的任务-翻译下载-单独下载 myTask-download-single
    `
    <h4 id="myTask-download-single">单独下载</h4>
    <ol class='ol-wrapper'>
      <li>我的任务页面，点击“操作”栏目下下载图标</li>
      <li>选择下载格式、是否高亮，点击“确定”</li>
    </ol>
    或
    <ol class='ol-wrapper'>
      <li>我的任务页面，点击文件名，跳转到在线预览</li>
      <li>对照预览页面，点击右下角“下载”</li>
      <li>选择下载格式、是否高亮，点击“确定”</li>
    </ol>
    <img class="gif" src="${trans_single_download}" />
    ` +
    // 我的任务-翻译下载-批量下载 myTask-download-batch
    `
    <h4 id="myTask-download-batch">批量下载</h4>
    <ol class='ol-wrapper'>
      <li>我的任务页面，批量勾选需要下载的文档</li>
      <li>点击左下角“下载”</li>
      <li>选择下载格式、是否高亮，点击“确定”</li>
    </ol>
    <img class="gif" src="${trans_batch_download}" />
    `
)

// 术语库
contentMap.set(
  'termLibrary',
  `<h2 id="termLibrary">术语库</h2>支持中英双语术语干预，用户上传领域术语语料，让机翻在各行业下表现更专业、更地道。
    例如，小明翻译“Alice likes to write papers”时，希望翻译结果中保留Alice的英文内容，可以利用术语库功能，将Alice原文、译文填入术语表词条中，这样译文结果就输出为“Alice 喜欢写论文”。
    <img class="gif" src="${term_library}" />
    在【术语库】界面，支持上传、更新、修改、下载、删除术语库中的词表、词条` +
    // 术语库-新建词表 termLibrary-creat-vocabulary
    `
    <h3 id="termLibrary-creat-vocabulary">新建词表</h3>使用术语库的第一步就是新建词表，用户下载官方提供的模板后自行填写需要的中英双语词汇，填写完毕后根据以下步骤上传：
    <ol class='ol-wrapper'>
      <li>点击进入【术语库】界面</li>
      <li>点击“新建”</li>
      <li>输入词表名称→选择翻译语言→下载模板文件.xlsx进行填写<span class="red-remark">（注：务必按照模板文件样式填写）</span>→上传本地xlsx词表表格→点击“发布词表”→词表新建成功</li>
    </ol>
    <img class="gif" src="${term_library_creat}" />` +
    // 术语库-更新词表 termLibrary-update-vocabulary
    `
    <h3 id="termLibrary-update-vocabulary">更新词表</h3>词表支持动态扩充维护，当用户积累到新的词条时，可对词表进行扩充更新，具体流程如下：
    <ol class='ol-wrapper'>
      <li>个人术语库页面下，点击词表右侧上传图标</li>
      <li>上传表格→勾选重复词条是否覆盖（勾选后，新上传文档中的重复词条将覆盖现有词条）→点击“确定”→词条更新完毕</li>
    </ol>
    <img class="gif" src="${term_library_update}" /> ` +
    // 术语库-修改词表 termLibrary-modify-vocabulary
    `<h3 id="termLibrary-modify-vocabulary">修改词表</h3>词表支持动态更新，历史词条有更优质的译法，或词表名需要修改，可以点击词表名称进入词表编辑页面。` +
    // 术语库-修改词表-添加词条 termLibrary-modify-vocabulary-add
    `
    <h4 id="termLibrary-modify-vocabulary-add">添加词条</h4>当用户需要单独添加某一个词条时，操作如下：
    <ol class='ol-wrapper'>
      <li>进入某词表页面，单击右下方“添加”</li>
      <li>输入原文、译文→勾选是否保持原文（勾选则译文保持和原文一致）→点击确定→添加成功</li>
    </ol>
    <img class="gif" src="${term_libray_modify_add}" />
    ` +
    // 术语库-修改词表-修改词条 termLibrary-modify-vocabulary-modify
    `
    <h4 id="termLibrary-modify-vocabulary-modify">修改词条</h4>当用户需要单独修改某一个词条时，操作如下：
    <ol class='ol-wrapper'>
      <li>进入某词表页面，点击词条右侧修改图标</li>
      <li>修改原文/译文→勾选是否保持原文（勾选则译文保持和原文一致）→点击确定→修改成功</li>
    </ol>
    <img class="gif" src="${term_library_modify_modify}" />
    ` +
    // 术语库-修改词表-删除词条 termLibrary-modify-vocabulary-delete
    `
    <h4 id="termLibrary-modify-vocabulary-delete">删除词条</h4>当用户需要删除词条时，操作如下：
    <h5>单独删除</h5>
    <ol class='ol-wrapper'>
      <li>进入某词表页面，直接点击词条右侧删除图标</li>
    </ol>
    <img class="gif" src="${term_library_modify_single_delete}" />
    <h5>批量删除</h5>
    <ol class='ol-wrapper'>
      <li>进入某词表页面，勾选想要删除的词条</li>
      <li>左下角点击删除</li>
    </ol>
    <img class="gif" src="${term_library_modify_batch_delete}" />
    ` +
    // 术语库-删除词表 termLibrary-delete-vocabulary
    `
    <h3 id="termLibrary-delete-vocabulary">删除词表</h3>支持单独删除和批量删除词表。当用户需要删除某些词表时，具体流程如下：
    ` +
    // 术语库-删除词表-单独删除  termLibrary-delete-vocabulary-single
    `
    <h4 id="termLibrary-delete-vocabulary-single">单独删除</h4>
    <ol class='ol-wrapper'>
      <li>术语库页面下，点击“操作”栏目下删除图标</li>
    </ol>
    <img class="gif" src="${term_library_delete_single}" />
    ` +
    // 术语库-删除词表-批量删除 termLibrary-delete-vocabulary-batch
    `
    <h4 id="termLibrary-delete-vocabulary-batch">批量删除</h4>
    <ol class='ol-wrapper'>
      <li>术语库页面下，勾选想要删除的词表</li>
      <li>点击左下角“删除”</li>
    </ol>
    <img class="gif" src="${term_library_delete_batch}" />
    ` +
    // 术语库-下载词表 termLibrary-download-vocabulary
    `
    <h3 id="termLibrary-download-vocabulary">下载词表</h3>支持词表单独下载和批量下载，具体流程如下：
    ` +
    // 术语库-下载词表-单独下载 termLibrary-download-vocabulary-single
    `
    <h4 id="termLibrary-download-vocabulary-single">单独下载</h4>
    <ol class='ol-wrapper'>
      <li>术语库页面下，点击“操作”栏目下下载图标</li>
    </ol>
    <img class="gif" src="${term_library_download_single}" />
    ` +
    // 术语库-下载词表-批量下载 termLibrary-download-vocabulary-batch
    `
    <h4 id="termLibrary-download-vocabulary-batch">批量下载</h4>
    <ol class='ol-wrapper'>
      <li>术语库页面下，勾选想要下载的词表</li>
      <li>点击左下角“下载”</li>
    </ol>
    <img class="gif" src="${term_library_download_batch}" />
    `
)

export { contentMap }
